import { defineComponent } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getPreferredLanguage } from '@/i18n';

export default defineComponent({
    setup() {
        const route = useRoute();
        const { params, query } = route;
        const router = useRouter();

        router.push({
            name: 'report-list',
            params: {
                knowledgeModelAlias: params.knowledgeModelAlias,
            },
            query: {
                token: query.token,
                language: getPreferredLanguage(route),
            },
        });
    },
});
